import PropTypes from 'prop-types';
// icons
import { Icon } from '@iconify/react';
// @mui
import { Box } from '@mui/material';
import React from 'react';

// ----------------------------------------------------------------------

interface IconifyProps {
  icon: React.ReactNode | string;
  sx?: object;
  width?: number;
  height?: number;
}

export default function Iconify({ icon, sx, width, height, ...other }: IconifyProps) {
  // @ts-ignore
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} width={width} height={height}/>;
}
